import { HttpHandler } from 'msw'

import { disputes } from './disputes'
import { orders } from './orders'
import { refills } from './refills'
import { sales } from './sales'

export const transactions: HttpHandler[] = [
    ...disputes,
    ...orders,
    ...refills,
    ...sales,
]
